import { useEffect } from "react"

const usePreventClickJacking = () => {
  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location = window.self.location
    }
  }, [])
}

export default usePreventClickJacking
